class SmartcapAccessories extends HTMLElement {
  constructor() {
    super();

    this._onSectionLoad = this._onSectionLoad.bind(this);
    this._abortController = null;
  }

  connectedCallback() {
    this._init();
    document.addEventListener('shopify:section:load', this._onSectionLoad);
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:section:load', this._onSectionLoad);

    if (this._abortController) {
      this._abortController.abort();
      this._abortController = null;
    }
  }

  _onSectionLoad(event) {
    if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) {
      return;
    }

    this._init();
  }

  _init() {
    if (this._abortController) {
      this._abortController.abort();
    }

    this._abortController = new AbortController();

    const buttons = Array.from(this.querySelectorAll('[data-filter]'));
    const cards = Array.from(this.querySelectorAll('.sc-acc__card'));
    const cartButtons = Array.from(this.querySelectorAll('[data-sc-acc-add-to-cart]'));

    buttons.forEach((button) => {
      button.addEventListener(
        'click',
        () => {
          buttons.forEach((filterButton) => {
            filterButton.classList.remove('sc-acc__filter-btn--active');
          });

          button.classList.add('sc-acc__filter-btn--active');

          const filter = button.dataset.filter;

          cards.forEach((card) => {
            if (filter === 'all' || card.dataset.category === filter) {
              card.classList.remove('sc-acc__card--hidden');
            } else {
              card.classList.add('sc-acc__card--hidden');
            }
          });
        },
        { signal: this._abortController.signal }
      );
    });

    cartButtons.forEach((button) => {
      button.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          this._addToCart(button);
        },
        { signal: this._abortController.signal }
      );
    });
  }

  async _addToCart(button) {
    const variantId = button.dataset.variantId;

    if (!variantId || button.getAttribute('aria-disabled') === 'true' || button.classList.contains('is-loading')) {
      return;
    }

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    try {
      const addUrl = window.routes?.cart_add_url || '/cart/add.js';
      const cartUrl = window.routes?.cart_url || '/cart.js';
      const cartJsonUrl = cartUrl.endsWith('.js') ? cartUrl : `${cartUrl}.js`;

      const addResponse = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      });

      if (!addResponse.ok) {
        throw new Error('Unable to add product to cart.');
      }

      const cartResponse = await fetch(cartJsonUrl, {
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!cartResponse.ok) {
        throw new Error('Unable to refresh cart.');
      }

      const cart = await cartResponse.json();
      this._updateHeaderCartCount(cart.item_count);
    } catch (error) {
      console.error(error);
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  }

  _updateHeaderCartCount(itemCount) {
    const smartcapBadge = document.querySelector('.sc-header__cart-badge');

    if (smartcapBadge) {
      smartcapBadge.textContent = itemCount;
      smartcapBadge.classList.toggle('sc-header__cart-badge--empty', itemCount === 0);
    }

    const dawnBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');

    if (dawnBubble) {
      dawnBubble.textContent = itemCount;
    }
  }
}

if (!customElements.get('smartcap-accessories')) {
  customElements.define('smartcap-accessories', SmartcapAccessories);
}
